export default __webpack_public_path__ + "static/media/svg-3.335c6aa8.svg";